import styled from '@emotion/styled'
import { colors, fontFamilies, BorderRadius } from '@configs/styles/config'

export const HeroWrapper = styled.section`
  width: 100%;
  padding: 0rem;
  background: linear-gradient(180deg, #130b28 0%, #0f0b1a 100%);
  color: ${colors.uguWhite};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 795px;
  position: relative; /* create stacking context so background can be absolutely positioned */
`

export const HeroContainer = styled.div`
  width: 100%;
  /* max-width: 1200px; */
  display: grid;
  grid-template-columns: 1fr 1fr;

  align-items: center;

  position: relative;
  z-index: 1; /* ensure content sits above the background image */

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`

export const Left = styled.div`
  position: relative; /* containing block for decorative gradient */
  z-index: 1; /* ensure text sits above the gradient */
  padding: 5rem 1rem 1rem 1rem;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  @media (min-width: 640px) {
    padding: 5rem 2rem;
  }
  @media (min-width: 769px) {
    padding: 5rem 2rem;
  }
  @media (min-width: 1024px) {
    padding: 5rem 0;
    margin: auto;
    max-width: 474px;
  }
  @media (min-width: 1324px) {
    padding: 0rem 0;
    margin: auto;
    max-width: 439px;
  }
`

export const Eyebrow = styled.div`
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 2px;
`

export const Title = styled.h1`
  font-family: ${fontFamilies.semiBold};
  font-weight: 600;
  font-size: 86px;
  line-height: 1.02;
  margin: 0 0 1rem 0;
  @media (max-width: 640px) {
    font-size: 74px;
    line-height: 1;
  }
`

export const Description = styled.p`
  color: rgba(255, 255, 255, 0.68);
  font-size: 1.05rem;
  max-width: 46rem;
  margin-bottom: 1.6rem;
`

export const Actions = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const PrimaryButton = styled.button`
  display: inline-block;
  padding: 0.9rem 2rem;
  background: ${colors.uguWhite};
  color: ${colors.uguPurple};
  border-radius: ${BorderRadius.large};
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
`

export const SecondaryButton = styled.button`
  display: inline-block;
  padding: 0.9rem 2rem;
  background: transparent;
  color: ${colors.uguWhite};
  border-radius: ${BorderRadius.large};
  border: 1px solid rgba(255, 255, 255, 0.12);
  text-decoration: none;
  cursor: pointer;
`

export const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
  position: relative;

  min-height: 795px;
  @media (max-width: 1024px) {
    min-height: auto;
  }
  /* background-color: red; */
  img {
    /* max-height: 613px;
    width: auto;
    position: absolute;
    left: 0;
    object-fit: cover; */
    @media (max-width: 1024px) {
      margin-bottom: -38%;
      width: 100%;
      height: auto;
    }
  }
`

export const RightBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  display: block;
  & > span {
    position: absolute !important;
    inset: 0 !important;
  }
`

export const Background = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  display: block;
  /* let the background image fill and preserve aspect */
  & > span {
    position: absolute !important;
    inset: 0 !important;
  }
`

/* Eclipse */

export const LeftGradientEclipse = styled.div`
  position: absolute;
  width: 465px;
  height: 213px;
  left: -111px;
  top: -47px;

  background: linear-gradient(
    180deg,
    rgba(113, 129, 255, 0.2) 0%,
    rgba(237, 176, 255, 0.092) 100%
  );
  filter: blur(68.9127px);

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
`
export const RightGradientEclipse = styled.div`
  position: absolute;
  width: 381.98px;
  height: 381.98px;
  right: -111px;
  top: -48.6px;

  background: linear-gradient(
    180deg,
    #7181ff 0%,
    rgba(245, 138, 37, 0) 100%,
    #7061a3 100%
  );
  filter: blur(43.7921px);

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
`
export const RightGradientEclipse2 = styled.div`
  position: absolute;

  position: absolute;
  width: 522.04px;
  height: 522.04px;
  right: -201.86px;
  top: -17.4px;

  background: linear-gradient(
    180deg,
    #7181ff 0%,
    rgba(237, 176, 255, 0.46) 100%
  );
  filter: blur(87.5842px);

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
`
